import React from "react";

const paths: Record<string, React.ReactNode> = {
	plane: (
		<path
			d="M12 3l1.5 7L21 13l-7.5 1L12 21l-1.5-7L3 13l7.5-1z"
			strokeLinejoin="round"
		/>
	),
	ops: (
		<>
			<rect x="4" y="4" width="16" height="16" rx="1" />
			<path d="M9 9h.01M15 9h.01M9 13h.01M15 13h.01" />
		</>
	),
	pin: (
		<>
			<path d="M12 21s7-5.5 7-11a7 7 0 10-14 0c0 5.5 7 11 7 11z" />
			<circle cx="12" cy="10" r="2.5" />
		</>
	),
	tag: (
		<>
			<path d="M3 7v6l8 8 8-8-8-8H7a4 4 0 00-4 2z" />
			<circle cx="8" cy="9" r="1" />
		</>
	),
	act: <path d="M3 12h4l3 8 4-16 3 8h4" strokeLinejoin="round" />,
	shield: <path d="M12 3l7 3v5c0 5-3.5 8-7 10-3.5-2-7-5-7-10V6z" />,
	wrench: (
		<path d="M15 7a4 4 0 01-5 5l-5 5 2 2 5-5a4 4 0 005-5l-2 2-2-2 2-2z" />
	),
	news: (
		<>
			<rect x="4" y="4" width="16" height="16" rx="1" />
			<path d="M8 9h8M8 13h8M8 17h5" />
		</>
	),
};

export function Icon({ name }: { name: string }) {
	return (
		<svg
			viewBox="0 0 24 24"
			width={21}
			height={21}
			fill="none"
			stroke="currentColor"
			strokeWidth={1.6}
		>
			{paths[name] ?? paths.ops}
		</svg>
	);
}
